import { render, staticRenderFns } from "./formCreateMDFE.vue?vue&type=template&id=1610a322"
import script from "./formCreateMDFE.vue?vue&type=script&lang=js"
export * from "./formCreateMDFE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1610a322')) {
      api.createRecord('1610a322', component.options)
    } else {
      api.reload('1610a322', component.options)
    }
    module.hot.accept("./formCreateMDFE.vue?vue&type=template&id=1610a322", function () {
      api.rerender('1610a322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fiscalDocuments/mdfe/components/form/formCreateMDFE.vue"
export default component.exports